//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../Routing/Routing.PathStockBuilder.js";
import "../no/ugmath.js";
let d=[[[0,"ElbowSnapSettings",1,"Routing.ElbowSnapSettings",0],[0,"LinearPathSettings",1,"Routing.LinearPathSettings",0],[0,"PathStockBuilder",1,"Routing.PathStockBuilder",0]],[[["location"],"AddPreviewControlPoint",{R_:{preview_rcp:"Routing.ControlPoint"}},1,0],[["preview_rcp","point"],"SetControlPointDefiningPoint",{},2,0],[["preview_rcp","position","object"],"SetControlPointDefiningObject",{},3,0],[[],"RemoveLastNonPreviewControlPoint",{},0,0],[[],"SettingChanged",{},0,0],[[],"GetLastControlPoint",{R_:{last_rcp:"Routing.ControlPoint"}},0,0],[["isNewControlPointRequired"],"SetIsNewControlPointRequired",{},1,0],[["isEccentricModeSelected"],"SetIsEccentricModeSelected",{},1,0],[[],"GetParentSegmentOfEccentricSegment",{R_:{parentSegment:"Routing.ISegment"}},0,0],[["parentSegment"],"SetParentSegmentOfEccentricSegment",{},1,0]],[]];
SPLM.Routing.LinearPathBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.LinearPathBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;